import styled from 'styled-components';
import { IconButton as MuiIconButton } from '@mui/material';

export const IconButton = styled(MuiIconButton)`
  && {
    background-color: ${({ theme }) => theme.primary.main};
    color: ${({ theme }) => theme.white};
    &:hover {
      background-color: ${({ theme }) => theme.primary.dark};
    }

    svg {
        color: ${({ theme }) => theme.white};
        fill:  ${({ theme }) => theme.white};
    }
  }
`;
